import React, { memo } from "react";
import { Icon } from "components/Icon/Icon";
import cx from "classnames";
import * as identify from "utils/treeUtils";
import { IconButton } from "components/IconButton/IconButton";
import s from "../Styles.module.scss";
import { EditNodeTypes } from "../EditNodeTypes";

export const LeftControls = memo(
  ({
    data,
    hasChildren,
    handleToggleNode,
    isNodeOpen,
    handleCreateNode,
    options,
    isPasteMode,
    translations,
    nodeId,
  }) => (
    <>
      {hasChildren && !identify.isRoot(data) && (
        <Icon
          onClick={(e) => {
            e.stopPropagation();
            !isPasteMode && handleToggleNode();
          }}
          iconName={
            isNodeOpen ? "chevron-down-regular" : "chevron-right-regular"
          }
          prefix="trox"
          className={cx(
            "icon-16  mx-1 cursor-pointer position-relative",
            s.folderIcon,
          )}
        />
      )}
      {(identify.isFolder(data) || identify.isRoot(data)) &&
        !options.createNodeDisabled && (
          <IconButton
            testId="addFolderButton"
            id={`addFolder${nodeId}`}
            icon="plus-regular"
            iconClassName="icon-12"
            onClick={(e) => {
              e.stopPropagation();
              handleCreateNode();
            }}
            className={cx(
              "mx-1 p-0_5 bg-white position-relative z-1",
              isPasteMode && "cursor-not-allowed opacity-20 pe-none",
            )}
            tooltipText={translations.folder.addLayer}
            disabled={isPasteMode}
          />
        )}
    </>
  ),
);

export const RightControls = memo(
  ({
    data,
    isPasteMode,
    handleToggleEditMode,
    handleCopyNode,
    handleDuplicateNode,
    handleDeleteNode,
    options,
    isNodeOptimistic,
    translations,
    nodeId,
    openDownloadModal,
    hasConfig,
  }) => (
    <div
      className={cx(
        "d-flex flex-row align-items-center justify-content-end",
        s.borderBetween,
      )}
    >
      {identify.isFolder(data) && !options.editNodeDisabled && (
        <IconButton
          testId="editFolderButton"
          id={`editFolder${nodeId}`}
          icon="pencil-light"
          iconClassName="icon-16"
          onClick={() => handleToggleEditMode(EditNodeTypes.TITLE)}
          className={cx(
            "px-2 border-0",
            isPasteMode && "cursor-not-allowed opacity-20 pe-none",
          )}
          tooltipText={translations.folder.editNode}
          disabled={isPasteMode}
        />
      )}
      {(identify.isFolder(data) ||
        identify.isWizardRootFolder(data) ||
        identify.isTroxNetcomFolderRoot(data)) &&
        !options.duplicateNodeDisabled && (
          <IconButton
            id={`duplicateFolder${nodeId}`}
            tooltipText={translations.folder.duplicateNode}
            testId="duplicateFolderButton"
            icon="duplicate-light"
            iconClassName="icon-16"
            onClick={handleDuplicateNode}
            className={cx(
              "px-2 border-0",
              isPasteMode && "cursor-not-allowed opacity-20 pe-none",
            )}
            disabled={isPasteMode}
          />
        )}
      {!identify.isRoot(data) && !options.copyNodeDisabled && (
        <IconButton
          id={`copyFolder${nodeId}`}
          tooltipText={translations.folder.copyNode}
          testId="copyIcon"
          icon="copy-light"
          iconClassName="icon-16"
          onClick={handleCopyNode}
          className={cx(
            "px-2 border-0",
            isPasteMode && "cursor-not-allowed opacity-20 pe-none",
          )}
          disabled={isPasteMode}
        />
      )}
      {!options.downloadModalDisabled &&
        (identify.isFolder(data) || identify.isWizardRootFolder(data)) && (
          <IconButton
            id={`downloadModal${nodeId}`}
            tooltipText={translations.product.download}
            testId="downloadIcon"
            iconPrefix="trox"
            icon="arrow-down-bracket-light"
            iconClassName="icon-16"
            onClick={openDownloadModal}
            className={cx(
              "px-2 border-0",
              (isPasteMode || !hasConfig) &&
                "cursor-not-allowed opacity-20 pe-none",
            )}
            disabled={isPasteMode || !hasConfig}
          />
        )}
      {(identify.isFolder(data) ||
        identify.isWizardRootFolder(data) ||
        identify.isTroxNetcomFolderRoot(data)) &&
        !options.deleteNodeDisabled && (
          <IconButton
            id={`deleteFolder${nodeId}`}
            tooltipText={translations.folder.deleteNode}
            testId="deleteIcon"
            icon="trash-can-light"
            iconClassName="icon-16"
            onClick={handleDeleteNode}
            className={cx(
              "px-2 border-0",
              (isNodeOptimistic || isPasteMode) &&
                "cursor-not-allowed opacity-20 pe-none",
            )}
            disabled={isPasteMode || isNodeOptimistic}
          />
        )}
    </div>
  ),
);
